import cx from 'classnames'
import { type PropsWithChildren, type ReactNode, Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { ErrorFallback } from '../../feedback/errorFallback/ErrorFallback'
import { FullscreenSpinner } from '../../feedback/fullscreenSpinner/FullscreenSpinner'
import { paperStyles } from '../../libs/paperStyles'
import { SidebarLayout } from './SidebarLayout'

export type PageProps = PropsWithChildren & {
  ErrorFallback?: typeof ErrorFallback
  ContentRight?: ReactNode
  childrenWrapperClassName?: string
  sidebarClassName?: string
  style?: React.CSSProperties
}

export const Page = ({
  ErrorFallback: CustomErrorFallback,
  ContentRight,
  children,
  childrenWrapperClassName,
  sidebarClassName,
  style,
}: PageProps) => (
  <div
    className={cx('relative flex min-h-0 min-w-0 grow shrink')}
    style={style}
  >
    <div
      className={cx(
        'flex flex-1 flex-col overflow-auto scroll-shadow h-full',
        'gap-3 *:mx-3', // would have been cleaner with just padding but that would introduce x-padding on the sticky scroll and trying to break free of that would introduce horizontal scroll
        paperStyles(),
        childrenWrapperClassName,
      )}
    >
      <Suspense fallback={<FullscreenSpinner position="relative" />}>
        <ErrorBoundary FallbackComponent={CustomErrorFallback ?? ErrorFallback}>
          {children}
        </ErrorBoundary>
      </Suspense>
    </div>
    {ContentRight && (
      <SidebarLayout
        ErrorFallback={CustomErrorFallback ?? ErrorFallback}
        className={sidebarClassName}
      >
        {ContentRight}
      </SidebarLayout>
    )}
  </div>
)
